export const ENABLED = true
export const DISABLED = false

export const LOAN_TYPE_FILTER = 'LOAN_TYPE_FILTER'
export const FULL_STORY = 'FULL_STORY'
export const ZABLE = 'ZABLE'
export const BANKRATE_IFRAME = 'BANKRATE_IFRAME'
